export default {
  tenants: {
    name: 'Account',
    table: 'te_tenants',
    descriptionField: 'tenantCode'
  },
  branches: {
    name: 'Branches',
    table: 'br_branches',
    descriptionField: 'name'
  },
  'call-blocking': {
    name: 'Call Blocking',
    table: 'bl_blacklists',
    descriptionField: 'callerId'
  },
	campaigns: {
    name: 'Campaigns',
    table: 'ca_campaigns',
    descriptionField: 'name'
  },
  huntlists: {
    name: 'Call Group',
    table: 'hu_huntlists',
    descriptionField: 'name'
  },
  queues: {
    name: 'Call Queue',
    table: 'qu_queues',
    descriptionField: 'name'
  },
  'conference-bridges': {
    name: 'Conference Room',
    table: 'cr_conferencerooms',
    descriptionField: 'name'
  },
  customs: {
    name: 'Custom Destination',
    table: 'cu_customs',
    descriptionField: 'name'
  },
  devices: {
    name: 'Device',
    table: 'ph_phones',
    descriptionField: 'name'
  },
  donotcalls: {
    name: 'Do Not Call List',
    table: 'dc_donotcalls',
    descriptionField: 'name'
  },
  locations: {
    name: 'E911 Location',
    table: 'el_emergency_locations',
    descriptionField: 'name'
  },
  extensions: {
    name: 'Extension',
    table: 'ex_extensions',
    descriptionField: 'number'
  },
  features: {
    name: 'Feature Code',
    table: 'fe_features',
    descriptionField: 'comment'
  },
  'device-models': {
    name: 'Phone Model',
    table: 'pm_phonemodels',
    descriptionField: 'name'
  },
  dids: {
    name: 'Phone Number',
    table: 'di_dids',
    descriptionField: 'number'
  },
  mediafiles: {
    name: 'Media File',
    table: 'me_mediafiles',
    descriptionField: 'name'
  },
  musiconholds: {
    name: 'Music On Hold',
    table: 'mu_musiconholds',
    descriptionField: 'name'
  },
  'number-porting': {
    name: 'Port Request',
    table: '',
    descriptionField: 'orderId'
  },
  'paging-groups': {
    name: 'Paging Group',
    table: 'pa_paginggroups',
    descriptionField: 'name'
  },
  'routing-profiles':{
    name: 'Routing Profile',
    table: 'rp_routingprofiles',
    descriptionField: 'name'
  },

  'short-numbers': {
    name: 'Short Number',
    table: 'sn_shortnumbers',
    descriptionField: 'number'
  },
  conditions: {
    name: 'Time of Day',
    table: 'co_conditions',
    descriptionField: 'name'
  },
  users: {
    name: 'User',
    table: 'us_users',
    descriptionField: 'email'
  },
  ivrs: {
    name: 'Virtual Receptionist',
    table: 'iv_ivrs',
    descriptionField: 'name'
  },
  voicemails: {
    name: 'Voicemail',
    table: 'voicemail',
    descriptionField: 'mailbox'
  },
};
